import { Pipe, PipeTransform, inject } from "@angular/core";
import { SelectionRepository } from "common/selection/state/selection.repository";
import { getIdKeyOfTypeId } from "common/selection/helper/selection-helper";
import TypedId = stages.core.TypedId;

@Pipe({
	name: "selectionStoreIsPartiallySelected",

	pure: false,
})
export class SelectionStoreIsPartiallySelectedPipe implements PipeTransform {
	private selectionRepository = inject(SelectionRepository);

	transform(
		// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Remove this comment and fix warnings!
		item: any,
		storeIdentifier: string,
		_toggleCounter: number, // underscore needed to pass "never read lint warning" because we need it to trigger pipe run
		dynamicStore: boolean,
		// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Remove this comment and fix warnings!
		idFnNew?: (item: any) => TypedId,
	): boolean {
		if (!item) {
			return false;
		}

		// In the combined associations detail view, the targetType is the type we need to use
		const type = item.type ?? item.targetType;

		if (!idFnNew && !type) {
			return false;
		}

		const typedId = idFnNew ? idFnNew(item) : { typeIdent: type.ident ?? type, id: item.id };

		const entity = dynamicStore
			? this.selectionRepository.getEntityDynamic(storeIdentifier, getIdKeyOfTypeId(typedId))
			: this.selectionRepository.getEntityCommon(getIdKeyOfTypeId(typedId), storeIdentifier);

		if (entity) {
			return !!entity.indeterminate && !entity.isSelected;
		}
		return false;
	}
}
